/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

/**
 * Translations which will have missing translations for specific language from CKE.
 * @type CKE_TRANSLATIONS Translations
 */
export const CKE_TRANSLATIONS = {
  pt: {
    Aquamarine: 'ÁGUA-MARINHA',
    Black: 'PRETO',
    Blue: 'AZUL',
    'Block quote': 'Citação em Bloco',
    Column: 'Coluna',
    'Header column': 'Coluna de Cabeçalho',
    'Insert column left': 'Inserir coluna à esquerda',
    'Insert column right': 'Inserir coluna à direita',
    'Insert media': 'Inserir mídia',
    'Delete column': 'Apagar coluna',
    'Decrease indent': 'DIMINUIR RECUO',
    'DIM GRAY': 'CINZA FOSCO',
    Gray: 'CINZA',
    Green: 'VERDE',
    'Increase indent': 'AUMENTAR RECUO',
    'Light blue': 'AZUL CLARO',
    'Light green': 'VERDE CLARO',
    'Light grey': 'CINZA CLARO',
    Orange: 'LARANJA',
    Purple: 'ROXO',
    Red: 'VERMELHO',
    Row: 'Linha',
    'Header row': 'Linha de cabeçalho',
    'Insert row above': 'Inserir linha acima',
    'Insert row below': 'Inserir linha abaixo',
    'Delete row': 'Excluir linha',
    'Merge cells': 'Mesclar células',
    'Merge cell up': 'Unir a célula acima',
    'Merge cell down': 'Mesclar a célula abaixo',
    'Merge cell right': 'Mesclar a célula à direita',
    'Merge cell left': 'Mesclar a célula à esquerda',
    'Split cell vertically': 'Divida a célula verticalmente',
    'Split cell horizontally': 'Divida a célula horizontalmente',
    'Show more items': 'EXIBIR MAIS ITENS',
    Turquoise: 'TURQUESA',
    White: 'BRANCO',
    Yellow: 'AMARELO',
    'Dark red': 'VERMELHO ESCURO',
    Brown: 'CASTANHO',
    'Dark green': 'VERDE ESCURO',
    'Dark purple': 'ROXO ESCURO',
    'Dark gray': 'CINZA ESCURO',
    'Dark yellow': 'AMARELO ESCURO',
    'Dark blue': 'AZUL ESCURO',
    Pink: 'COR-DE-ROSA',
  },
  sv: {
    Aquamarine: 'MARINBLÅTT',
    Black: 'SVART',
    Blue: 'BLÅ',
    Column: 'Kolumn',
    'Header column': 'Rubrikkolumn',
    'Insert column left': 'Infoga kolumn till vänster',
    'Insert column right': 'Infoga kolumn till höger',
    'Delete column': 'Radera kolumn',
    'Decrease indent': 'MINSKA INDRAGNING',
    'Dim grey': 'DIMMGRÅ',
    Grey: 'GRÅ',
    Green: 'GRÖN',
    'Increase indent': 'ÖKA INDRAGNING',
    'Light blue': 'LJUSBLÅ',
    'Light green': 'LJUSGRÖN',
    'Light grey': 'LJUSGRÅ',
    Orange: 'ORANGE',
    Purple: 'LILA',
    Red: 'RÖD',
    Row: 'Rad',
    'Header row': 'Rubrikrad',
    'Insert row above': 'Infoga rad ovan',
    'Insert row below': 'Infoga rad nedan',
    'Delete row': 'Radera rad',
    'Merge cells': 'Sammanfoga celler',
    'Merge cell up': 'Slå ihop cellen',
    'Merge cell down': 'Slå samman cellen',
    'Merge cell right': 'Slå samman cellen till höger',
    'Merge cell left': 'Slå ihop cellen till vänster',
    'Show more items': 'VISA FLER OBJEKT',
    'Split cell vertically': 'Dela cellen vertikalt',
    'Split cell horizontally': 'Dela cellen horisontellt',
    Turquoise: 'TURKOS',
    White: 'VIT',
    Yellow: 'GUL',
    'Dark red': 'MÖRKRÖD',
    Brown: 'BRUN',
    'Dark green': 'MÖRKGRÖN',
    'Dark purple': 'MÖRKLILA',
    'Dark gray': 'MÖRKGRÅ',
    'Dark yellow': 'MÖRKGUL',
    'Dark blue': 'MÖRKBLÅ',
    Gray: 'GRÅ',
    Pink: 'ROSA',
  },
  nl: {
    Turquoise: 'TURKOOIS',
    Black: 'ZWART',
    'Dark red': 'DONKER ROOD',
    Brown: 'BRUIN',
    'Dark green': 'DONKERGROEN',
    'Dark purple': 'DONKER PAARS',
    'Dark gray': 'DONKERGRIJS',
    Red: 'ROOD',
    'Dark yellow': 'DONKER GEEL',
    'Dark blue': 'DONKERBLAUW',
    Purple: 'PAARS',
    Gray: 'GRIJS',
    Orange: 'ORANJE',
    Green: 'GROENTE',
    Blue: 'BLAUW',
    Pink: 'ROZE',
  },
  fi: {
    'Insert media': 'Aseta media',
    Black: 'MUSTA',
    'Dark red': 'TUMMANPUNAINEN',
    Brown: 'RUSKEA',
    'Dark green': 'TUMMAVIHREÄ',
    'Dark purple': 'TUMMIA LILLAA',
    'Dark gray': 'TUMMAN HARMAA',
    Red: 'PUNAINEN',
    'Dark yellow': 'TUMMAKELTAINEN',
    'Dark blue': 'TUMMAN SININEN',
    Purple: 'VIOLETTI',
    Gray: 'HARMAA',
    Orange: 'ORANSSI',
    Green: 'VIHREÄ',
    Blue: 'SININEN',
    Pink: 'VAALEANPUNAINEN',
  },
  no: {
    Black: 'SVART',
    'Dark red': 'MØRK RØD',
    Brown: 'BRUN',
    'Dark green': 'MØRKE GRØNN',
    'Dark purple': 'MØRK LILLA',
    'Dark gray': 'MØRKEGRÅ',
    Red: 'RØD',
    'Dark yellow': 'MØRKEGUL',
    'Dark blue': 'MØRKEBLÅ',
    Purple: 'LILLA',
    Gray: 'GRÅ',
    Orange: 'ORANSJE',
    Green: 'GRØNN',
    Blue: 'BLÅ',
    Pink: 'ROSA',
  },
  fr: {
    Black: 'NOIR',
    'Dark red': 'ROUGE FONCÉ',
    Brown: 'BRUN',
    'Dark green': 'VERT FONCÉ',
    'Dark purple': 'VIOLET FONCÉ',
    'Dark gray': 'GRIS FONCÉ',
    Red: 'ROUGE',
    'Dark yellow': 'JAUNE FONCÉ',
    'Dark blue': 'BLEU FONCÉ',
    Purple: 'VIOLET',
    Gray: 'GRIS',
    Orange: 'ORANGE',
    Green: 'VERT',
    Blue: 'BLEU',
    Pink: 'ROSE',
  },
  es: {
    Black: 'NEGRO',
    'Dark red': 'ROJO OSCURO',
    Brown: 'MARRÓN',
    'Dark green': 'VERDE OSCURO',
    'Dark purple': 'PÚRPURA OSCURO',
    'Dark gray': 'GRIS OSCURO',
    Red: 'ROJO',
    'Dark yellow': 'AMARILLO OSCURO',
    'Dark blue': 'AZUL OSCURO',
    Purple: 'PÚRPURA',
    Gray: 'GRIS',
    Orange: 'NARANJA',
    Green: 'VERDE',
    Blue: 'AZUL',
    Pink: 'ROSA',
  },
  en: {
    Black: 'BLACK',
    'Dark red': 'DARK RED',
    Brown: 'BROWN',
    'Dark green': 'DARK GREEN',
    'Dark purple': 'DARK PURPLE',
    'Dark gray': 'DARK GRAY',
    Red: 'RED',
    'Dark yellow': 'DARK YELLOW',
    'Dark blue': 'DARK BLUE',
    Purple: 'PURPLE',
    Gray: 'GRAY',
    Orange: 'ORANGE',
    Green: 'GREEN',
    Blue: 'BLUE',
    Pink: 'PINK',
  },
  de: {
    Black: 'SCHWARZ',
    'Dark red': 'DUNKELROT',
    Brown: 'BRAUN',
    'Dark green': 'DUNKELGRÜN',
    'Dark purple': 'DUNKELLILA',
    'Dark gray': 'DUNKELGRAU',
    Red: 'ROT',
    'Dark yellow': 'DUNKELGELB',
    'Dark blue': 'DUNKELBLAU',
    Purple: 'LILA',
    Gray: 'GRAU',
    Orange: 'ORANGE',
    Green: 'GRÜN',
    Blue: 'BLAU',
    Pink: 'ROSA',
  },
};
